import { Component, computed, inject, Input } from '@angular/core';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { SLA_VIOLATION } from '../../../service/request-page.enum';
import { requestInterface } from 'src/app/util/interfaces/request';

@Component({
	selector: 'pcp-request-page-tab-solution-area-history',
	standalone: true,
	imports: [],
	templateUrl: './request-page-tab-solution-area-history.component.html',
	styleUrl: './request-page-tab-solution-area-history.component.scss',
})
export class RequestPageTabSolutionAreaHistoryComponent {
	private readonly labelsService = inject(LabelsService);
	public readonly dateService = inject(DateService);

	SLA_VIOLATION = SLA_VIOLATION;

	labels: LabelsInterface;

	@Input() requestData: requestInterface;

	constructor() {
		this.labels = computed(() => {
			return this.labelsService.labels();
		})();
	}
}
